import FilterForm from 'components/forms/FilterForm';
import { Form, FormProps, Input, Select } from 'antd';
import { IGraduateCourse } from 'interfaces/graduate_courses';
import { useSelect } from '@refinedev/antd';

export interface IEquivalenciesFilterForm {
  courseId: string;
  by_status: string;
  by_name: string;
  by_email: string;
}

interface EquivalenciesFilterProps {
  searchFormProps: FormProps<IEquivalenciesFilterForm>;
}

export const EquivalenciesFilter = ({
  searchFormProps
}: EquivalenciesFilterProps) => {
  const { selectProps: courseSelectProps } = useSelect<IGraduateCourse>({
    resource: 'graduate_courses',
    optionLabel: 'name',
    optionValue: 'id',

    onSearch: value => [
      {
        field: 'filter[name]',
        operator: 'eq',
        value
      }
    ],

    pagination: {
      mode: 'server'
    }
  });

  return (
    <FilterForm searchFormProps={searchFormProps}>
      <Form.Item name="by_name">
        <Input placeholder="Nome do aluno" />
      </Form.Item>

      <Form.Item name="by_email">
        <Input placeholder="E-mail do aluno" />
      </Form.Item>

      <Form.Item name="courseId">
        <Select
          {...courseSelectProps}
          allowClear
          placeholder="Curso regulado"
        />
      </Form.Item>

      <Form.Item name="by_status">
        <Select placeholder="Status" allowClear defaultValue="submitted">
          <Select.Option key={'submitted'}>Submetido</Select.Option>
          <Select.Option key={'approved'}>Aprovado</Select.Option>
          <Select.Option key={'rejected'}>Rejeitado</Select.Option>
          <Select.Option key={'canceled'}>Cancelado</Select.Option>
          <Select.Option key={'validating'}>Validando</Select.Option>
        </Select>
      </Form.Item>
    </FilterForm>
  );
};
